/**
 * Escalas de raio, tipografia e espaçamento das telas de Clientes.
 *
 * As COREs não moram aqui — vêm de `colors.designSystem` (app/styles/theme/colors).
 * Estas três escalas existem em arquivo próprio porque o tema do app não tem
 * equivalente para elas, e os valores precisam bater exatamente com os do
 * customer-management-front para o porte não introduzir deriva visual.
 *
 * Origem: bloco `@theme` de customer-management-front/src/app/globals.css.
 */

export const radii = {
  extraSmall: '3px',
  /** Itens do segmented control (Figma 1760:2366) — fica entre o extra-small e o small. */
  segment: '4px',
  small: '5px',
  medium: '7px',
  full: '99px',
} as const;

/**
 * Chaves numéricas espelham os tokens `--font-size-font-size-*` do MFE.
 * `13`/`14`/`16`/`20`/`32` são os tamanhos de marca; `xl2`/`xl3` são os aliases
 * que o MFE usava via `text-2xl`/`text-3xl`.
 *
 * Nota de porte: `text-sm` do Tailwind é 14px — o MESMO valor de `14`.
 * Ambos viram `fontSizes[14]`.
 */
export const fontSizes = {
  13: '13px',
  14: '14px',
  16: '16px',
  20: '20px',
  xl2: '24px',
  32: '32px',
  xl3: '32px',
} as const;

/**
 * Passos declarados como token no MFE (classes `@utility` do tipo
 * `gap-spacing-24`, `pt-spacing-40`). Sempre px, iguais ao número da chave.
 *
 * Espaçamento escrito na escala NUMÉRICA do Tailwind (`gap-2`, `px-4`) não vem
 * daqui — converte literalmente para rem. Ver PORTING.md.
 */
export const spacing = {
  4: '4px',
  8: '8px',
  10: '10px',
  12: '12px',
  16: '16px',
  24: '24px',
  32: '32px',
  40: '40px',
  48: '48px',
} as const;

export const fontFamily = {
  body: "'Noto Sans', sans-serif",
  title: "'Noto Sans', sans-serif",
} as const;
